<template>
  <Dialog
    :visible="modelValue"
    @update:visible="handleClose"
    :modal="true"
    :closable="false"
    :closeOnEscape="false"
    :draggable="false"
    :style="{ width: '450px' }"
    header="⚠️ PROBLEMA CON LA FACTURACIÓN"
    class="timeout-dialog"
  >
    <div class="dialog-content">
      <!-- Icono de advertencia -->
      <div class="icon-container">
        <i
          class="pi pi-exclamation-triangle"
          style="font-size: 3.5rem; color: #f59e0b"
        ></i>
      </div>

      <!-- Mensaje principal -->
      <div class="message-box">
        <h3>La venta se guardó correctamente</h3>
        <p class="warning-text">
          Pero hubo un <strong>problema de conexión</strong> al facturar.
        </p>
        <p class="info-text">
          La factura podría haberse generado en Impuestos.
        </p>
      </div>

      <!-- ID de venta -->
      <div class="venta-info">
        <i class="pi pi-info-circle mr-2"></i>
        <span
          >Venta: <strong>#{{ ventaId }}</strong></span
        >
      </div>

      <!-- ✅ Mensaje de advertencia simple -->
      <div class="warning-message">
        <i class="pi pi-exclamation-circle"></i>
        <span>
          <strong>Importante:</strong> La venta ya está guardada. Debes
          verificar el estado de la factura.
        </span>
      </div>

      <!-- Opciones compactas -->
      <div class="options-container">
        <h4 class="options-title">¿Qué deseas hacer?</h4>

        <div class="buttons-row">
          <Button
            label="BUSCAR FACTURA"
            icon="pi pi-search"
            class="p-button-warning p-button-lg"
            :loading="loading"
            :disabled="loading"
            @click="$emit('buscar-factura', ventaId)"
          />

          <Button
            label="IR AL DETALLE"
            icon="pi pi-eye"
            class="p-button-info p-button-lg"
            :disabled="loading"
            @click="$emit('ir-detalle', ventaId)"
          />
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
export default {
  name: "TimeoutFacturaDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    ventaId: {
      type: [Number, null],
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "buscar-factura", "ir-detalle"],
  methods: {
    handleClose(value) {
      // ❌ NO permitir cerrar el modal manualmente
      if (!value) {
        return;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.timeout-dialog {
  ::v-deep(.p-dialog-header) {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    color: white;
    padding: 1.25rem;

    .p-dialog-title {
      font-weight: bold;
      font-size: 1.1rem;
    }

    .p-dialog-header-icon {
      display: none;
    }
  }

  ::v-deep(.p-dialog-content) {
    padding: 1.5rem;
  }
}

.dialog-content {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  .icon-container {
    display: flex;
    justify-content: center;
    animation: bounce 2s infinite;
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  .message-box {
    text-align: center;

    h3 {
      color: #2d3748;
      font-size: 1.2rem;
      font-weight: 700;
      margin-bottom: 0.5rem;
    }

    .warning-text {
      color: #d97706;
      font-size: 0.95rem;
      margin-bottom: 0.4rem;
      font-weight: 600;
    }

    .info-text {
      color: #4b5563;
      font-size: 0.9rem;
    }
  }

  .venta-info {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e0f2fe;
    padding: 0.6rem;
    border-radius: 6px;
    color: #0369a1;
    font-size: 0.95rem;

    strong {
      color: #0c4a6e;
      font-size: 1.05rem;
    }
  }

  // ✅ Nuevo estilo para mensaje de advertencia simple
  .warning-message {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #92400e;
    font-size: 0.85rem;
    text-align: center;
    line-height: 1.4;

    i {
      color: #f59e0b;
      font-size: 1rem;
      flex-shrink: 0;
    }

    strong {
      color: #78350f;
    }
  }

  .options-container {
    .options-title {
      color: #374151;
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0.75rem;
      text-align: center;
    }

    .buttons-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.75rem;

      .p-button {
        transition: all 0.3s ease;
        font-size: 0.9rem;

        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        ::v-deep(.p-button-label) {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
